import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'harp-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.css'],
})
export class FormErrorComponent implements OnInit {
  @Input() formGroup;

  constructor() {}

  ngOnInit(): void {}

  public get hasError(): boolean {
    return this.formGroup.errors && this.formGroup.touched;
  }

  public get errorMessages(): Record<string, string | null> {
    const errorMessages = Object.keys(this.formGroup.errors).reduce(
      (acc, key) => {
        return key.includes('harp')
          ? { ...acc, [key]: this.formGroup.errors[key] }
          : acc;
      },
      {},
    );

    return Object.keys(errorMessages).length ? errorMessages : {};
  }
}
